// extracted by mini-css-extract-plugin
export default {"danh_sach":"OanTuTi_danh_sach__0Wu2J","lua_chon":"OanTuTi_lua_chon__kI20d"};